import { render, staticRenderFns } from "./cpt-button.vue?vue&type=template&id=e1a07bac&scoped=true"
import script from "./cpt-button.vue?vue&type=script&lang=js"
export * from "./cpt-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a07bac",
  null
  
)

export default component.exports